export enum FindCarePageType {
  Landing = 'landing',
  Results = 'results',
  DetailOverview = 'details',
  DetailCostEstimate = 'detailsCostEstimate'
}
